export default __webpack_public_path__ + "static/media/woman-enjoying-her-financially-independence-while-buying-car.123fe487.png";